const bareSemver = /(\d)+\.(\d)+\.(\d)+/
const onlyBareSemver = /^(\d)+\.(\d)+\.(\d)+$/
const onlySha = /^[0-9a-f]{40}$/

const validVersion = version => onlyBareSemver.test(version) || onlySha.test(version)

function replaceUrlVersion(url, version) {
  return url && validVersion(version) ? url.replace(bareSemver, version) : url
}

export default replaceUrlVersion



// WEBPACK FOOTER //
// ./~/santa-main-r/src/lib/common/replaceUrlVersion.js